import { useCallback, useMemo } from 'react'

import { ApolloError } from '@apollo/client'

import { formatErrorMessages, getErrorCodes } from '~/utils/formatErrorMessages'
import useReservationCreate from '~/utils/hooks/useReservationCreate'

import { modalProps } from '~/components/Checkout/CheckoutPage/MarketingConsentModal/MarketingConsentModalUtils'
import MarketingConsentModal from '~/components/Checkout/CheckoutPage/MarketingConsentModal/MarketingConsentModalView'
import { errors as errorMessages, shouldTriggerMarketingModal } from '~/constants/errors'
import { useCreateDailyReservationMutation, useCreateFestivalReservationMutation } from '~/generated/graphql'
import { gt } from '~/locale'
import { useToast } from '~/shared/atoms/Toast'
import { useModal } from '~/shared/molecules/Modal'

export const useCreateReservation = () => {
  const modal = useModal()
  const toast = useToast()

  const handleReservationError = useCallback(
    (error: ApolloError) => {
      let errors = formatErrorMessages(error)
      const errorCodes = getErrorCodes(error)
      if (shouldTriggerMarketingModal(errorCodes)) {
        modal.open(modalProps, <MarketingConsentModal handleAccepted={modal.close} />)
      }

      // FIX Pre-Sale
      if (errorCodes.includes('discount_not_found')) {
        errors = [gt.tp('Error', errorMessages.no_presale_code)]
      }

      errors.map(err =>
        toast.add({
          message: err,
          type: 'error',
          containerSelector: '#FERToastContainer',
          size: 'small',
        })
      )
    },
    [modal, toast]
  )

  const reservationCreateOptions = useMemo(
    () => ({
      onError: handleReservationError,
    }),
    [handleReservationError]
  )

  const [createFestivalReservation] = useReservationCreate({
    useCreateReservationMutation: useCreateFestivalReservationMutation,
    options: reservationCreateOptions,
  })
  const [createDailyReservation] = useReservationCreate({
    useCreateReservationMutation: useCreateDailyReservationMutation,
    options: reservationCreateOptions,
  })

  return {
    createDailyReservation,
    createFestivalReservation,
  }
}
